import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026">
      <p className="text-[15px] text-slate-600 leading-relaxed">
        SML Municipal Consulting ("we", "us", "our") is committed to protecting your privacy. This policy explains how we
        collect, use and safeguard your personal information when you use our website or request our services. We process
        personal information in line with the Protection of Personal Information Act (POPIA) of South Africa.
      </p>

      <LegalSection heading="1. Information We Collect">
        <p>When you complete our Request for Quotation or enquiry form, we may collect your name, company name, email
        address, telephone number, council account number, property details and the details of your municipal query.</p>
        <p>We may also collect limited technical information (such as browser type and pages visited) to help us improve
        the website.</p>
      </LegalSection>

      <LegalSection heading="2. How We Use Your Information">
        <p>We use your information solely to respond to your enquiry, prepare a quotation, provide the municipal
        consulting or metering services you request, and communicate with you about your matter. We do not sell your
        personal information.</p>
      </LegalSection>

      <LegalSection heading="3. Sharing Your Information">
        <p>Where necessary to assist with your municipal query, and only with your authorisation, we may liaise with the
        relevant municipality or utility provider on your behalf. We do not share your information with third parties for
        marketing purposes.</p>
      </LegalSection>

      <LegalSection heading="4. Data Security">
        <p>We take reasonable technical and organisational measures to protect your personal information against loss,
        unauthorised access and misuse. However, no method of transmission over the internet is completely secure.</p>
      </LegalSection>

      <LegalSection heading="5. Retention">
        <p>We retain enquiry and account information only for as long as necessary to provide our services and to comply
        with legal or record-keeping obligations.</p>
      </LegalSection>

      <LegalSection heading="6. Your Rights">
        <p>You may request access to, correction of, or deletion of your personal information at any time by contacting
        us using the details below, subject to applicable legal requirements.</p>
      </LegalSection>

      <LegalSection heading="7. Changes to This Policy">
        <p>We may update this policy from time to time. Any changes will be posted on this page with a revised date.</p>
      </LegalSection>
    </LegalLayout>
  );
}
